<template>
  <v-container class="my-10">
      <v-flex align-self-center>
        <v-img :src="imgSrc" max-height="512" contain></v-img>
      </v-flex>
  </v-container>
</template>

<script>

export default {
  name: 'Banner',
  props: {
    image: {
      type: String,
      required: true
    }
  },
  computed: {
    imgSrc(){
      return `https://cdn.vladlink.ru/banners/pay/${this.image}.png`
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Banner.vue